import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from './index.module.css';

const TableSkeleton = ({ columns = [], rowCount = 10, height = 20 }) => {
  return (
    <div className={`table-container`}>
      <table className={`table ${styles.winnersTable}`}>
        <thead className={`thead ${styles.winnersTableHeader}`}>
          <tr>
            {columns.map((col, index) => (
              <th key={index} className={`colIndex === 0 && theadColumnOne  ${styles.colOne}`}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody className={`tbody ${styles.winnersTbBody}`}>
          {Array.from({ length: rowCount }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((_, colIndex) => (
                <td key={colIndex} className={`colIndex === 0 && tdataColumnOne`}>
                  <Skeleton
                    height={height}
                   baseColor="var(--manatee)"
                    // customHighlightBackground="linear-gradient(90deg, var(--manatee) 25%, var(--violet) 50%, var(--manatee) 75%)"
                  />

                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeleton;